import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi, { x } from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { BLSupplierWiseSchema } from "../BLSupplierWiseSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import MessageModal from '../../../../UI/Modal/MessageModal';
import Autocomplete from '@material-ui/lab/Autocomplete';

const screenCode = 'BLSUPPLIERWIEREPORT'
export function BLSupplierWiseReport(props) {

    const componentRef = useRef();
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [summeryData, setSummeryData] = useState([]);
    const [summeryData2, setSummeryData2] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        factoryID: "0",
        collectionPointID: "0",
        toDate: "",
        fromDate: "",
        minimumGrossQuantityID: "0",
        Date: new Date().toISOString().split('T')[0],
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: "",
        date: ""
    });
    const [summeryValues, setSummeryValues] = useState({
        netTot: 0,
        grossTot: 0,
        actualTot: 0,
        bagTot: 0,
        deductTot: 0,
        isActive: ''
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(BLSupplierWiseSchema).options({ allowUnknown: true });
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const [deductionTypeNamesOfTable, setDeductionTypeNamesOfTable] = useState([]);

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
        setsearchData({
            ...searchData,
            factoryID: '0'
        });
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )

    }, [searchData.factoryID]);

    useEffect(() => {
        setdata([])
    }, [searchData])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBLSUPPLIERWISEREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray)

        }

        setsearchData({
            ...searchData,
            groupID: token.groupID,
            factoryID: token.operationEntityID,
            Date: new Date().toISOString().split('T')[0]
        });

        trackPromise(
            getGroupsForDropDown()
        );
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionPoint = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.factoryID);
        setCollectionPoint(collectionPoint);
    }


    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, BLSupplierWiseSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function handleSearch(e) {
        e.preventDefault();
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        let selectedValues = {
            CollectionPointID: parseInt(searchData.collectionPointID),
            Date: searchData.Date,
            operationEntityID: parseInt(searchData.factoryID)

        }
        let result = await service.getReportData(selectedValues);
        if (result.length > 0) {
            setSummeryData2(result);
            var copyOfRsult = _.cloneDeep(result)
            var csvHeaders = [
                { label: "Supplier Name", value: "collectionPointName" },
                { label: "Supplier Code", value: "bplDivisionID" },
                { label: "Bag Count", value: "count" },
                { label: "Actual Amount", value: "factualAmount" },
                { label: "Gross Amount", value: "fGrossAmount" }
            ];
            var result1 = [];
            copyOfRsult.forEach(x => {
                if (result1.length === 0) {
                    result1.push(x.fDeductionTypeName);
                    csvHeaders.push({ label: x.fDeductionTypeName, value: x.fDeductionTypeName });
                } else {
                    var duplicateName = result1.find(y => y === x.fDeductionTypeName);
                    if (!duplicateName) {
                        result1.push(x.fDeductionTypeName);
                        csvHeaders.push({ label: x.fDeductionTypeName, value: x.fDeductionTypeName });
                    }
                }
            });

            csvHeaders.push({ label: "Net Amount", value: "fNetAmount" });
            setDeductionTypeNamesOfTable(result1);
            let groupedFactoryWeighResult = groupByTag(result);
            let factoryWeighKeys = Object.keys(groupedFactoryWeighResult);
            let factoryWeighArrayCollection = [];
            factoryWeighKeys.forEach(x => {
                var res = pivotFactoryWeighResult(groupedFactoryWeighResult[x]);
                factoryWeighArrayCollection.push(res);
            });

            let bagTot = 0;
            let actualTot = 0;
            let grossTot = 0;
            let netTot = 0;
            let deductTot = [];
            let isActive = '';

            factoryWeighArrayCollection.forEach(x => {
                bagTot = bagTot + x.count;
                actualTot = actualTot + x.factualAmount;
                grossTot = grossTot + x.fGrossAmount;
                netTot = netTot + Math.floor(x.fNetAmount);
                isActive = x.isActive;
                result1.forEach(y => {
                    if (x[y]) {
                        deductTot.push({
                            property: y,
                            value: checkUndifind(x[y])
                        });
                    }
                });
            });

            const result3 = deductTot.reduce((obj, el) => {

                obj[el.property] = (obj[el.property] || 0) + el.value;

                return obj;
            }, {});

            var resultqqqq = Object.entries(result3);

            var temlArry = [];
            for (const key in resultqqqq) {
                temlArry.push({
                    name: resultqqqq[key][0],
                    value: resultqqqq[key][1]
                })
            }
            setSummeryData(temlArry);

            setSummeryValues({
                ...summeryValues,
                netTot: netTot,
                grossTot: grossTot,
                actualTot: actualTot,
                bagTot: bagTot,
                deductTot: deductTot,
                isActive: isActive
            });
            setCsvHeaders(csvHeaders);
            setdata(factoryWeighArrayCollection);
            setCsvData(factoryWeighArrayCollection);
            setIsTableHide(false);
            setButtonHide(false);
            getSelectedDropdownValuesForReport(searchData);
        } else {
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }


    }

    function checkUndifind(value) {
        if (value === undefined) {
            return 0;
        }
        else {
            return value;
        }
    }

    const convertFrom24To12Format = (time24) => {
        var timeSplit = time24.split(":");
        return timeSplit[0] + ":" + timeSplit[1];
    }

    function groupByTag(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['collectionPointName'] + "-" + obj['startTime'].split("T")[0];

            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    function pivotFactoryWeighResult(data) {
        var result = {};
        data.forEach(function (e) {
            var a = e.collectionPointName;

            if (!this[a]) {
                let time = convertFrom24To12Format(e.startTime.split('T')[1].split('.')[0]);

                this[a] = {
                    factualAmount: e.fActualAmount,
                    ftagNumber: e.collectionPointName,
                    fstartTime: time,
                    ffullTime: e.startTime.split('T')[0],
                    fNetAmount: e.fNetAmount,
                    fGrossAmount: Math.floor(e.fGrossAmount),
                    count: e.count,
                    collectionPointName: e.collectionPointName,
                    bplDivisionID: e.bplDivisionID,
                    isActive: e.isActive
                }
                result = this[a]
            }
            this[a][e.fDeductionTypeName] = e.fTotalDeduction;

        }, {});
        return result;

    }


    function createFile() {
        var settings = {
            sheetName: 'BL Supplier Wise Report',
            fileName: 'BL Supplier Wise Report',
            writeOptions: {}
        }

        var newArray1 = {
            collectionPointName: "Total",
            bplDivisionID: "",
            count: summeryValues.bagTot,
            factualAmount: summeryValues.actualTot,
            fGrossAmount: summeryValues.grossTot,
            fNetAmount: summeryValues.netTot
        }

        summeryData.forEach(x => {
            newArray1[x.name] = x.value;
        });

        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            collectionPointName: "Group :" + groups[searchData.groupID],
            count: "Operation Entity : " + operationEntity[searchData.factoryID],
            factualAmount: 'Supplier Name : ' + (collectionPoint[searchData.collectionPointID] == undefined || collectionPoint[searchData.collectionPointID] == null ? 'All' : collectionPoint[searchData.collectionPointID]),
        }

        copyOfCsv.push(newArray1, {}, {}, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.factoryID],
            collectionPoint: collectionPoint[searchForm.collectionPointID],
            date: searchForm.Date
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="BL Supplier Wise Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchData.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="groupID" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Operation Entity*</InputLabel>
                                        <Select
                                            fullWidth
                                            id="factoryID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="factoryID"
                                            value={searchData.factoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(
                                                Object.fromEntries(
                                                    Object.entries(operationEntity).filter(([key, value]) => {
                                                        if (key === "0" || !value) return false;
                                                        if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                            return true;
                                                        }
                                                        return Object.values(multipleEstates).includes(value);
                                                    })
                                                )
                                            )}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="factoryID" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <Autocomplete
                                            id="collectionPointID"
                                            options={Object.entries(collectionPoint || {}).filter(([k, v]) => k !== "0" && v).map(([key, value]) => ({ id: key, label: value }))}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={(() => {
                                                const opts = Object.entries(collectionPoint || {}).filter(([k, v]) => k !== "0" && v).map(([key, value]) => ({ id: key, label: value }));
                                                return opts.find(o => o.id === searchData.collectionPointID) || null;
                                            })()}
                                            onChange={(e, newValue) => {
                                                const error = { ...errors };
                                                const errorMessage = validateProperty({ name: 'collectionPointID', value: newValue ? newValue.id : '0' }, BLSupplierWiseSchema);
                                                errorMessage ? error['collectionPointID'] = errorMessage : delete error['collectionPointID'];
                                                setErrors(error);
                                                setsearchData({
                                                    ...searchData,
                                                    collectionPointID: newValue ? newValue.id : '0'
                                                })
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Supplier Name" variant="outlined" fullWidth error={!!errors["collectionPointID"]} />
                                            )}
                                        />
                                    </div>
                                    <div className="col-md pb-1">
                                        <TextField
                                            id="Date"
                                            label="Date *"
                                            name="Date"
                                            type="date"
                                            fullWidth
                                            value={searchData.Date}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            disabled={validate(schema, searchData)}
                                            type="button"
                                            className="btn btn-primary"
                                            value="Generate"
                                            onClick={e => trackPromise(handleSearch(e))}
                                            hidden={searchButtonHide}
                                        />
                                    </div>
                                </div>
                                {data.length == 0 ? null :

                                    <TableContainer component={Paper} style={{ border: "1px solid black" }}>
                                        <Table aria-label="simple table" style={{ border: "1px solid black" }}>
                                            <TableHead style={{ border: "1px solid black" }}>
                                                <TableRow
                                                    style={{ border: "2px solid black" }}>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                                        Supplier Name
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                                        Supplier Code
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                                        Bag Count
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                                        Actual Amount
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                                        Gross Amount
                                                    </TableCell>
                                                    {deductionTypeNamesOfTable.map((item) => (
                                                        <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align='center'>{item}</TableCell>
                                                    ))}
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>
                                                        Net Amount
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{ border: "1px solid black" }}>
                                                {data.map((row) => (
                                                    <TableRow key={row.employeeCode}
                                                        style={{
                                                            border: "2px solid black",
                                                            backgroundColor: row.isActive === false ? "lightgreen" : "inherit"
                                                        }}
                                                    >
                                                        <TableCell component="th" scope="row" style={{ border: "2px solid black" }}>
                                                            {row.collectionPointName}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>
                                                            {row.bplDivisionID}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }} >
                                                            {row.count}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>
                                                            {parseFloat(row.factualAmount).toFixed(2)}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>
                                                            {parseFloat(row.fGrossAmount).toFixed(2)}
                                                        </TableCell>
                                                        {deductionTypeNamesOfTable.map((column) => {
                                                            const value = row[column];
                                                            return (
                                                                <TableCell align='right' style={{ border: "2px solid black" }} >{value == undefined ? '-' : parseFloat(value).toFixed(2)}</TableCell>
                                                            );
                                                        })}
                                                        <TableCell align="right" tyle={{ border: "2px solid black" }}>{Math.floor(row.fNetAmount)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                            <TableBody style={{ border: "1px solid black" }}>
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="left">
                                                        Total
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="left">
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                                        {summeryValues.bagTot}
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                                        {parseFloat(summeryValues.actualTot).toFixed(2)}
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                                        {parseFloat(summeryValues.grossTot).toFixed(2)}
                                                    </TableCell>
                                                    {deductionTypeNamesOfTable.map((item) => {
                                                        var result = summeryData.find(y => y.name === item);
                                                        return (
                                                            <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align='right'>{result == undefined ? parseFloat(0).toFixed(2) : parseFloat(result.value).toFixed(2)}</TableCell>
                                                        );
                                                    })}
                                                    <TableCell style={{ fontWeight: "bold", border: "2px solid black" }} align="right">
                                                        {Math.floor(summeryValues.netTot)}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                                {data.length == 0 ? null :
                                    <div className="pt-2">
                                        <ReactToPrint
                                            documentTitle={"BL Supplier Wise Report"}
                                            trigger={() => <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                        <div hidden={true}>
                                            <CreatePdf ref={componentRef}
                                                deductionTypeNamesOfTable={deductionTypeNamesOfTable}
                                                data={data}
                                                searchData={selectedSearchValues}
                                                summeryData={summeryData}
                                                summeryValues={summeryValues}
                                            />
                                        </div>
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}

